import { render, staticRenderFns } from "./applayXh.vue?vue&type=template&id=05a978f8&scoped=true"
import script from "./applayXh.vue?vue&type=script&lang=js"
export * from "./applayXh.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a978f8",
  null
  
)

export default component.exports